







































import Vue from "vue";
import {ENDPOINTS, get} from "@/api/mainApi";
import {DonationCause} from "@/interfaces/organizationgroup/donationCause";

export default Vue.extend({
  props: {
    disabled: {
      default: false
    },
    readOnly: {
      default: false
    },
    clearable: {
      default: true
    },
    hideDetails: {
      default: true
    },
    onlyActive: {
      default: true
    },
    value: Object as () => DonationCause,
    rules: Array
  },
  data() {
    return {
      donationCauses: [],
      loading: false,
      setInitial: false,
      query: "",
      timerId: 0
    };
  },
  computed: {
    donationCause: {
      get: function (): DonationCause {
        return this.value;
      },
      set: function (newValue: DonationCause) {
        this.$emit('update:value', newValue)
      }
    },
  },
  methods: {
    async getDonationCauses(query: string) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(async () => {
        if (query.length > 1) {
          this.loading = true;
          this.donationCauses = await get(ENDPOINTS.DONATION_CAUSES + "/" + ENDPOINTS.SEARCH + "/" + query, {onlyActive: this.onlyActive});
          this.donationCauses = this.donationCauses.filter(donationCause => donationCause.name.length > 0)
          this.loading = false;
        }
      }, 250);

    },
    pushSelected(selected) {
      // used to set selected item
      this.donationCauses.push(selected)
    },
    t(label) {
      const $te = this.$te.bind(this);
      const $t = this.$t.bind(this);
      return $te(label) ? $t(label) : undefined;
    },
  },
  watch: {
    query(val) {
      if (val && val.length > 0 && !this.setInitial) {
        this.getDonationCauses(val)
      }
      this.setInitial = false
    },
    donationCause: {
      handler(val) {
        if (val) {
          this.setInitial = true
          this.pushSelected(val)
        }
      },
      immediate: true
    },
  }
});
